/*global geoip2, window, angular, console*/
(function () {

  'use strict';

  /**
   * @author Ronald Nicholls | Chester Rivas | Frank Song
   * @description factory for unifying the logic for getting language and province based on $rootScope object rui or ute or cookies
   * @ngdoc provider
   * @name uteLocale
   * @class ute-ui
   * @memberOf ute-ui
   */
  angular.module('ute.ui')

    .factory('uteLocale', ['$rootScope', function ($rootScope) {

      console.log('> uteLocale');

      /**
       * @type {object}
       * @property {function} language
       * @property {function} country
       * @property {function} province
       * @property {function} actualProvince
       * @property {function} locale
       */
      var uteLocale = {},
        actualProvince;

      /**
       * @description locale language with getter and setter
       * @returns {string}
       */
      Object.defineProperty(uteLocale, 'language', {
        get: function () {
          if (angular.isDefined($rootScope.userPref) && angular.isDefined($rootScope.userPref.language)) {
            return $rootScope.userPref.language.toLowerCase();
          }
          return 'en';
        },
        set: function (newValue) {
          $rootScope.userPref.language = newValue.toLowerCase();
        },
        configurable: true
      });

      /**
       * @description locale country
       * @returns {string}
       */
      Object.defineProperty(uteLocale, 'country', {
        get: function () {
          return 'ca';
        },
        set: angular.noop,
        configurable: true
      });

      /**
       * @description locale province
       * @returns {string}
       */
      Object.defineProperty(uteLocale, 'province', {
        get: function () {
          if (angular.isDefined($rootScope.userPref) && angular.isDefined($rootScope.userPref.province)) {
            return $rootScope.userPref.province.toLowerCase();
          }
          return 'ON';
        },
        set: function (newValue) {
          console.log('setting province');
          //uteCoreFactory.collections.userPref.province = newValue.toUpperCase();
          $rootScope.userPref.province = newValue.toUpperCase();
        },
        configurable: true
      });

      /**
       * @description actualProvince - actual province detected by geoip2
       * @returns {string}
       */
      Object.defineProperty(uteLocale, 'actualProvince', {
        get: function () {
          return actualProvince || 'ON';
        },
        set: function (newVal) {
          actualProvince = newVal;
        }
      });

      /**
       * @description locale - combination of language and province
       * @returns {string}
       */
      Object.defineProperty(uteLocale, 'locale', {
        get: function () {
          return uteLocale.language + '-' + uteLocale.country;
        },
        set: angular.noop,
        configurable: true
      });

      return uteLocale;


    }]);

})();
